import { useSearchParams } from 'react-router-dom'

import { Box, Card, Icon, Text } from '@factorialco/deprecated-design-system'
import { MeetingDetailFragment, MeetingExternalNotesFragment } from 'generated/resources/graphql'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { UploadTranscript } from './_Upload'

interface TranscriptProps {
  meeting: MeetingDetailFragment
}

interface ShowTranscriptProps {
  externalNote?: MeetingExternalNotesFragment
}

function ShowTranscript({ externalNote }: ShowTranscriptProps) {
  const [searchParams, setSearchParams] = useSearchParams()
  const isSidepanelOpen = searchParams.get('transcriptPanel') === 'open'
  const openPanel = () => setSearchParams({ transcriptPanel: 'open' })
  return (
    <Box width="full" gap="s24">
      <Card>
        <Card.Content>
          <Box flexDirection="row" flexGrow gap="s8">
            <Box onClick={openPanel}>
              <Icon.Medium icon="info-circle-line" color="grey800" />
            </Box>
            <Box>
              <Text size="200" weight="bold">
                {externalNote?.originalFileName || ''}
              </Text>
              <Text size="200">
                {externalNote?.uploader?.firstName || ''} {externalNote?.uploader?.lastName || ''}
              </Text>
            </Box>
          </Box>
        </Card.Content>
      </Card>
      <Sidepanel
        open={isSidepanelOpen}
        onClose={() => setSearchParams({})}
        width="wide"
        title={i18n.t('one_on_ones.meeting.transcript.title')}
      >
        {externalNote?.text || ''}
      </Sidepanel>
    </Box>
  )
}

export function Transcript({ meeting }: TranscriptProps) {
  const externalNotes = meeting?.externalNotes

  return (
    <Box width="full">
      <Text.Normal size="300" weight="semibold">
        {i18n.t('one_on_ones.meeting.transcript.title')}
      </Text.Normal>
      {externalNotes?.length ? (
        <ShowTranscript externalNote={externalNotes[0]} />
      ) : (
        <UploadTranscript meetingId={meeting.id} />
      )}
    </Box>
  )
}
